import React from 'react';
import moment from 'moment';
import { DateTimeInput } from './DateTimeInput.js';
import { getFieldSetting } from '../helpers/HelperFunctions.js';

const CalendarIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3.5" y="5" width="17" height="16" rx="3" />
        <path d="M3.5 9.5h17M8 3v4M16 3v4" />
    </svg>
);

const DateIntervalInput = (props) => {
    const { name, value, settings, minValue, maxValue, disabled } = props;

    const startFieldName = getFieldSetting(settings, 'StartField');
    const endFieldName = getFieldSetting(settings, 'EndField');

    const startDate = value?.[startFieldName] ?? '';
    const endDate = value?.[endFieldName] ?? '';

    // за замовчуванням дата не може бути раніше поточної, але поле може задати свої межі
    const nowDate = new Date();
    const minStartDate = minValue ?? moment(new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate())).format("YYYY-MM-DD");
    // кінцева дата обмежена знизу початковою, якщо та показана і вибрана
    const minEndDate = settings.hideStartDate || !startDate ? minStartDate : startDate;

    // повертаються лише ті дати, які показані в контролі, щоб приховане поле лишалось незмінним
    const changeHandle = (start, end) => {
        if (!props.onChange) return;
        const newValue = {};
        if (startFieldName && !settings.hideStartDate) newValue[startFieldName] = start;
        if (endFieldName && !settings.hideEndDate) newValue[endFieldName] = end;
        props.onChange({ target: { name: name, value: newValue } });
    }

    const startChangeHandle = (e) => {
        const start = e.target.value;
        // кінцева дата не може бути раніше початкової, тому скидається
        const resetEnd = start && endDate && new Date(start) > new Date(endDate);
        changeHandle(start, resetEnd ? '' : endDate);
    }

    const endChangeHandle = (e) => {
        changeHandle(startDate, e.target.value);
    }

    // react-datepicker відкривається лише кліком по самому значенню, а поле ширше за нього:
    // рамка, відступи та іконки календаря й шеврона на клік не реагували. Тому клік будь-де
    // в межах поля передаємо значенню. Поки календар відкритий, клік його закриває — інакше
    // передане натискання одразу відкривало б його знову.
    const containerClickHandle = (e) => {
        if (disabled) return;
        const container = e.target.closest?.('.date-input-contaner');
        if (!container || e.target.closest('.date-input-control')) return;
        if (document.querySelector('.react-datepicker')) return;
        container.querySelector('.date-input-control')?.click();
    }

    return (<div className={"date-interval-input" + (disabled ? " disabled" : "")} name={name} >
        <CalendarIcon />
        {!settings.hideStartDate && <div className="date-interval-item" onClick={containerClickHandle}>
            <div className="label">{getFieldSetting(settings, 'StartLabel')}</div>
            <DateTimeInput name={startFieldName} value={startDate} min={minStartDate} max={maxValue} disabled={disabled} onChange={startChangeHandle} />
        </div>}
        {!settings.hideStartDate && !settings.hideEndDate && <div className="date-interval-divider" />}
        {!settings.hideEndDate && <div className="date-interval-item" onClick={containerClickHandle}>
            <div className="label">{getFieldSetting(settings, 'EndLabel')}</div>
            <DateTimeInput name={endFieldName} value={endDate} min={minEndDate} max={maxValue} disabled={disabled} onChange={endChangeHandle} />
        </div>}
    </div>);
}

export default DateIntervalInput;
